export const hasNumeric = (str) => /[0-9]/.test(str?.trim());
export const hasSpecialCharacter = (str) => /[^a-zA-Z0-9 ]/.test(str?.trim());

export const isNameValid = (_name) => {
    if (_name.trim().length < 3) {
      return "Name must be greater than 3 char.";
    } else {
      if (hasNumeric(_name) || hasSpecialCharacter(_name)) {
        return "No numeric or special character allowed.";
      } else {
        return "";
      }
    }
  };

  export const isValidAddress = (_address) => {
    if (_address.trim().length < 5 || _address.trim().length > 100) {
      return "Address must more than 5 char or less than 100 char.";
    } else {
      return "";
    }
  };

  export const isEmailValid = (_email) => {
    if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(_email)) {
      return "";
    } else {
      return "Email is not valid.";
    }
  };

  export const isPhoneValid = (_phone) => {
    if (_phone.length === 10) {
      return "";
    } else {
      return "Mobile number must be 10 digits.";
    }
  };

  export const isAadharValid = (_aadhar) => {
    if (_aadhar.length === 12) {
      return "";
    } else {
      return "Aadhar number must be 12 digits.";
    }
  };

  export const isPanValid = (_pan) => {
    if (_pan.length === 10) {
      return "";
    } else {
      return "Pan number must be 10 digits.";
    }
  };

  export const formatDDMMYYYY = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
}

  export const isPinValid = (_pin) => {
    if (_pin.length === 6) {
      return "";
    } else {
      return "Pin must be only 6 digit.";
    }
  };

  export const isGreaterThan100Char = (_sentence) => {
    if (_sentence.length < 100) {
      return "";
    } else {
      return "Not more than 100 char is allowed.";
    }
  };

  export function isAlphanumeric(str) {
    return /^[a-zA-Z0-9]*$/.test(str);
  }

  export const calculateAgeFormDOB = (_date) => {
    const dob = new Date(_date);        
    const age = Math.abs(new Date(Date.now() - dob.getTime()).getUTCFullYear() - 1970);  
    return  age
  }



